@if (isOpen()) {
	<div class="auth-modal-backdrop" animate.leave="bt-sheet-leave" (click)="onBackdropClick($event)">
		<div class="auth-modal-container bt-sheet">
			<button
				class="auth-modal-close"
				(click)="onClose()"
				[disabled]="isLoading"
				[attr.aria-label]="'common.actions.close' | transloco"
				type="button">
				<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
					<line x1="18" y1="6" x2="6" y2="18"></line>
					<line x1="6" y1="6" x2="18" y2="18"></line>
				</svg>
			</button>

			<app-auth-form
				[isRegister]="currentMode"
				[errorMessage]="errorMessage"
				[showSuccessState]="showSuccessState"
				[loading]="isLoading"
				[isModal]="true"
				(formSubmit)="onFormSubmit($event)"
				(cancelMFA)="cancelMFA()"
				(googleLogin)="onGoogleLogin()"
				(appleLogin)="onAppleLogin()"
				(switchToLogin)="switchToLogin()"
				(switchToRegister)="switchToRegister()"
				(switchToResetPassword)="switchToResetPassword()" />
		</div>
	</div>
}
